import { IconNames } from '@blueprintjs/icons';
import { Button } from '@strata/react-buttons';
import { DialogWithForm } from '@strata/react-dialog';
import { SuccessToast } from '@strata/react-toast-message';
import { Formik } from 'formik';
import PropTypes from 'prop-types';

import { useDeleteRequestQueueMutation } from 'store/api/agoraMonitorApi';

export const DeleteRequestQueueDialog = ({ isOpen, onClose, queue = undefined }) => {
    const [deleteRequestQueue] = useDeleteRequestQueueMutation();

    return (
        <Formik
            initialValues={{}}
            enableReinitialize
            onSubmit={async () => {
                await deleteRequestQueue(queue.queueId).unwrap();
                SuccessToast({ message: `Queue "${queue.name}" deleted.` });
                onClose({ deleted: true });
            }}
        >
            {(formik) => (
                <DialogWithForm
                    dialogTitle="Delete queue"
                    headerIcon={IconNames.WARNING_SIGN}
                    isOpen={isOpen}
                    width={440}
                    secondaryButtonLabel="Cancel"
                    onSecondaryButtonClick={() => onClose()}
                    primaryButtonLabel="Yes, delete queue"
                    primaryButtonIntent={Button.Intent.DANGER}
                    isPrimaryButtonDisabled={formik.isSubmitting}
                    dialogContent={
                        <p>
                            Delete <strong>{queue?.name}</strong>? This cannot be undone.
                        </p>
                    }
                />
            )}
        </Formik>
    );
};

DeleteRequestQueueDialog.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    queue: PropTypes.shape({
        queueId: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired,
    }),
};
